import { create } from "zustand";
import { persist } from "zustand/middleware";

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;

type PaginationEntry = { page: number; pageSize: number };

type PropertyPaginationState = {
  paginationByClientId: Record<string, PaginationEntry>;
  setPage: (clientId: string, page: number) => void;
  setPageSize: (clientId: string, pageSize: number) => void;
};

/**
 * Per-client pagination (current page + rows-per-page), persisted to
 * localStorage so a user returning to the Properties list lands back on the
 * page and page size they left.
 */
export const usePropertyPaginationStore = create<PropertyPaginationState>()(
  persist(
    (set) => ({
      paginationByClientId: {},
      setPage: (clientId, page) =>
        set((state) => {
          const existing = state.paginationByClientId[clientId] ?? {
            page: DEFAULT_PAGE,
            pageSize: DEFAULT_PAGE_SIZE,
          };
          return {
            paginationByClientId: {
              ...state.paginationByClientId,
              [clientId]: { ...existing, page },
            },
          };
        }),
      setPageSize: (clientId, pageSize) =>
        set((state) => {
          const existing = state.paginationByClientId[clientId] ?? {
            page: DEFAULT_PAGE,
            pageSize: DEFAULT_PAGE_SIZE,
          };
          return {
            paginationByClientId: {
              ...state.paginationByClientId,
              [clientId]: { ...existing, pageSize },
            },
          };
        }),
    }),
    { name: "property-pagination" }
  )
);
